var map = {
	"./add_quote.png": "18e7",
	"./cars_quote.png": "92e3",
	"./flotte_quote.png": "9229",
	"./health_quote.png": "7c2d",
	"./house_quote.png": "6d61",
	"./life_quote.png": "5734",
	"./mrp_quote.png": "68b2",
	"./travel_quote.png": "b034",
	"./trc_quote.png": "6280"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1f5e";